import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirplayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airplay"}/>
}
